<template>
  <div v-if="files.length > 0" class="SearchFileList">
    <div
      class="file"
      v-for="item in files"
      :key="item.datum_id"
      :id="`datum-${item.datum_id}`"
      @click="onPreview(item)"
    >
      <div class="left">
        <div class="icon" :class="{ [getFileTypeName(item.docType)]: true }"></div>
        <span class="name">
          <span v-highlightKeywords:[keywords]="item.name"></span>
        </span>
        <span v-if="item.is_last_time_viewed === 1" class="last-viewed"> 上次学到 </span>
        <span v-else-if="item.is_viewed === 1" class="viewed"> 已学 </span>
        <span v-else class="unviewed"> 未学 </span>
      </div>
      <div class="right">
        <i class="el-icon-arrow-right" />
      </div>
    </div>
  </div>
</template>
<script>
import { generatePreviewVideo } from '@/utils/previewFile';
export default {
  name: 'SearchFileList',

  props: {
    list: {
      type: Array,
      default: () => [],
    },
    keywords: {
      type: String,
      default: '',
    },
    isViewedReport: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    files() {
      return this.list.map((item) => ({
        baichuan_video_id: item.baichuan_video_id,
        type: item.datum_id ? 1 : 0, //0: 表示点播课(无附件) 1: 表示资料（附件)
        datum_id: item.datum_id, //如果datum_id，则表示是资料(附件)，否则是课节标题（“点播课”）， 对于资料名称展示file_name， 点播课名称展示使用period_title。
        name: item.datum_id ? item.file_name : item.period_title,
        docType: item.doc_type, //doc_type 字段用于标识资料或点播课文件类型： 0 默认类型，1 视频类型 2音频类型 3 word 4 ppt 5 pdf 6 图片
        fid: item.fid?.split(';'),
        // file_url: item.file_url,
        course_basis_id: item.course_basis_id,
        // course_type: item.course_type,
        course_chapter_id: item.course_chapter_id,
        period_id: item.period_id,
        period_type: item.period_type,
        room_video_id: item.room_video_id,
        self_room_video_id: item.self_room_video_id,
        is_viewed: item.is_viewed,
        is_last_time_viewed: item.is_last_time_viewed,
      }));
    },
  },

  directives: {
    highlightKeywords(el, binding) {
      let highlightText = binding.value;
      const keywords = binding.arg;
      // if (!highlightText) return '';

      if (keywords) {
        highlightText = highlightText.replaceAll(
          keywords,
          `<span style="color: #F55;">${keywords}</span>`,
        );
      }

      el.innerHTML = highlightText;
    },
  },

  methods: {
    getFileTypeName(docType) {
      switch (docType) {
        case 1:
          return 'video';
        case 2:
          return 'audio';
        case 3:
          return 'word';
        case 4:
          return 'ppt';
        case 5:
          return 'pdf';
        case 6:
          return 'image';
        default:
          return 'unknown';
      }
    },
    async onPreview(file) {
      if (this.isViewedReport) {
        await this.$http.post('/api/app/myStudy/report', {
          type: file.type, //0: 表示点播课(无附件) 1: 表示资料（附件)
          course_basis_id: file.course_basis_id,
          course_chapter_id: file.course_chapter_id,
          datum_id: file.type === 1 ? file.datum_id : undefined, // type=0时，该字段可以不传或传0
        });

        this.$webSeeSendTrack({
          event_id: 'resource_search_result_item_click',
          event_type: 'click',
          data: {
            course_basis_id: file.course_basis_id,
            course_chapter_id: file.course_chapter_id,
            period_id: file.period_id,
            datum_id: file.type === 1 ? file.datum_id : undefined, // type=0时，该字段可以不传或传0
          },
        });
      }

      // 视频或音频
      if ([1, 2].includes(file.docType)) {
        console.log('file', file);
        let videoUrl = '';
        if (file.datum_id) {
          const data = await this.$http.get(`/backend-api/app/v2/chapterDatum/${file.datum_id}`);
          videoUrl = generatePreviewVideo(
            (data && data.transferMeta && data.transferMeta.data && data.transferMeta.data.dash) ||
              '',
          );
        } else {
          const data = await this.$http.get(
            `/backend-api/app/study/video/${file.baichuan_video_id}`,
          );
          videoUrl = generatePreviewVideo((data && data.dash && data.dash.url) || '');
        }
        console.log('videoUrl', videoUrl);
        if (videoUrl) {
          window.open(videoUrl, '_blank');
        } else {
          this.$message.error('获取视频预览地址失败');
        }
      } else if ([6].includes(file.docType)) {
        // 图片
        let data = await this.$http.get(`/backend-api/app/v2/chapterDatum/${file.datum_id}`);
        console.log(data);
        if (data.file_url) {
          window.open(data.file_url);
        } else {
          this.$message.error('文件不存在');
        }
      } else {
        // 跳转至预览文件页面
        window.open(`/preview_file?datum_id=${file.datum_id}`, '_blank');
      }
    },

    async onPreviewFirstFile() {
      this.onPreview(this.files[0]);
    },
    open(url) {
      let hasOrigin = false;
      try {
        const urlObj = new URL(url);
        // 如果 URL 对象成功创建，并且 origin 属性存在
        hasOrigin = !!urlObj.origin;
      } catch (e) {
        // 如果 URL 对象创建失败（例如，urlString 不是一个有效的 URL），则返回 false
        hasOrigin = false;
      }
      url = hasOrigin ? url : `${location.origin}${url}`;

      //桌面端内
      if (this.$store.state.desktop) {
        // 支持安全锁的版本
        if (this.$store.state.desktop.deviceInfo) {
          this.$router.push({
            name: 'Iframe',
            query: {
              url: this.ensureHttps(url),
            },
          });
        } else {
          this.$store.state.desktop.openurl(this.ensureHttps(url)); // 不支持安全锁的版本
        }
      } else {
        //桌面端外
        window.open(url);
      }
    },
    ensureHttps(url) {
      // 使用 URL 对象解析输入的 URL
      const parsedUrl = new URL(url);

      // 检查协议是否为 'https:'
      if (parsedUrl.protocol !== 'https:') {
        // 如果不是 'https:'，则修改为 'https:'
        parsedUrl.protocol = 'https:';
      }

      // 返回修改后的 URL 字符串
      return parsedUrl.toString();
    },
  },
};
</script>
<style lang="scss" scoped>
.SearchFileList {
  display: flex;
  flex-direction: column;
  gap: 16px;
  .file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    &:hover {
      .name {
        color: $primary-color !important;
      }
    }
    .left {
      display: flex;
      align-items: center;
      gap: 8px;
      .icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        background-size: 100% 100%;
        flex-shrink: 0;
        &.unknown {
          background-image: url('~@/assets/images/common/icons/flies/unknown.svg');
        }
        &.video {
          background-image: url('~@/assets/images/common/icons/flies/video.svg');
        }
        &.audio {
          background-image: url('~@/assets/images/common/icons/flies/audio.svg');
        }
        &.word {
          background-image: url('~@/assets/images/common/icons/flies/word.svg');
        }
        &.ppt {
          background-image: url('~@/assets/images/common/icons/flies/ppt.svg');
        }
        &.pdf {
          background-image: url('~@/assets/images/common/icons/flies/pdf.svg');
        }
        &.image {
          background-image: url('~@/assets/images/common/icons/flies/image.svg');
        }
      }
      .name {
        flex: 1;
        cursor: pointer;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        color: #1e1c22;
        line-height: 22px;
        word-wrap: break-word;
      }
      .last-viewed,
      .viewed,
      .unviewed {
        display: inline-block;
        padding: 2px 4px;
        border-radius: 4px;
        margin-left: 8px;
        font-size: 12px;
        line-height: 17px;
        background: #f0f3fc;
      }
      .last-viewed {
        font-size: 10px;
        line-height: 14px;
        color: #f55;
        background: #ffefec;
      }
      .viewed {
        color: #a6a6b1;
      }
      .unviewed {
        color: #46454e;
      }
    }
  }
}
</style>
